import rippleFactory from './Ripple'
import theme from './theme'

export default options => rippleFactory({ ...options, theme })
